module.exports = __webpack_public_path__ + "img/16.2ecbfd5f.jpg";